import React, { useEffect, useState } from 'react'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'

import { PostingScreen } from '../../../types/types'
import { PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (value: PostingScreen) => void
}

const Emotion: React.FC<IProps> = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [posting, setPosting] = useState<PostingTemplate>(props.posting)

  useEffect(() => {
    props.posting && setPosting(props.posting)
  }, [props.posting],
  )

  return (
    <>
      <ButtonComponent
        color='info'
        variant='text'
        text='zurück'
        onClick={() => props.changePostingScreen && props.changePostingScreen(PostingScreen.MAIN)}
      />
      Emotion einfügen
    </>
  )
}

export default Emotion
